import appStore from "store";
import api from "./api";
import {
  REGISTER_FORM,
  USER_STATUS,
  BANK_AUTH_STATUS,
  ID_NO_STATUS,
  EMAIL_SECURITY_STATUS,
  PHONE_SECURITY_STATUS,
  GOOGLE_SECURITY_STATUS,
  USER_VALUNTEER_STATUS,
  USER_BLOCKING_STATUS,
  QUERY_TYPE,
  PAGINATION,
} from "./constants";

const store = {
  namespaced: true,
  state: {
    orderList: [],
    totalCount: 0,
    pagination: PAGINATION,
    queryTypeList: QUERY_TYPE,
    queryType: QUERY_TYPE[0].value,
    userinfoDetail: {},
    userinfoDetailDialogVisible: false,
    dialogVisible: false,
    notedetail: {},
    countryCodeList: [],
    blockInfoList: [],
    pairsList: [],
    allCoins:[]
  },
  getters: {},
  mutations: {
    // setList(state, payload) {
    //   state.blockInfoList = payload.list.slice();
    //   state.totalCount = payload.totalCount;
    // },
    setOrderList(state, payload) {
      state.orderList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    setUserinfoDetailDialogVisible(state, payload) {
      state.userinfoDetailDialogVisible = payload;
    },
    setUserinfoDetail(state, payload) {
      state.userinfoDetail = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setPairsList(state, payload) {
      state.pairsList = payload;
    },
    setAllcoins(state, payload) {
      state.allCoins = payload;
    },
  },
  actions: {
    getOrderList({ commit }, data) {
      api.getOrderList(data).then((res) => {
        commit("setOrderList", res.data);
      });
    },
    exportExcel({commit},data){
       return api.exportExcel(data).then(res=>{
            return res
        })
    },
    getFbsPairs({commit}){
       return api.getFbsPairs().then(res=>{
            commit('setPairsList',res.data)
        })
    },
    getAllCoins({ commit }) {
      api.getAllCoins().then(({ data }) => {
        commit('setAllcoins', data);
      });
    },
  },
};

appStore.registerModule("financeTrade", store);
